import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {},
    uploadButton: {
      padding: "5px 20px",
      "& .MuiButton-startIcon": {
        marginRight: 0
      }
    },
    errorAlert: {
      display: "flex",
      alignItems: "center",
      color: theme.palette.error.light
    },
    errorAlertIcon: {
      marginRight: 5
    }
  }),
  { name: "PayslipUploader" }
);

export default useStyles;
